import { PartialEnvVarMap } from "../types/envVar";

const productionEnvVars: PartialEnvVarMap = {
  idApiUrl: "https://identity-management.prod.vibe.justworks.com",
  oktaAppClientId: "0oa666b7z4tAsWVyw697",
  oktaHostUrl: "https://login.justworks.com",
  rollbarPostClientToken: "2a6cf4edc90a4e9fa47a837f76143610",
  heapKey: "1234739207",
  heapLocalstorage: false,
  oktaCommonJwGroupId: "00g3jfwzuu1Q2C2kd697",
  uspClientId: "069506c2-2188-4965-a76b-07b01dae308d",
  uspHost: "usp-api.justworks.com",
  uspPixelHost: "usp.justworks.com",
  uspEnvironment: "production",
};

export default productionEnvVars;
